// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ejhT","delete":"styles_delete__3KKKF","update":"styles_update__xbbuv","add":"styles_add__83rC_"};